import React from "react";
import { Link } from "react-router-dom";
import AIHealthPanel from "../../components/ai/AIHealthPanel";
import { useAISettings } from "../../components/ai/aiRoutes";

// AI Studio > Usage: read-only provider health, token use and cost per route.
// Models and the API key are configured in Settings > AI.
export default function AIUsagePanel() {
  const { settings, loading, error } = useAISettings();
  return (
    <div className="space-y-4" data-testid="ai-usage">
      {error && <p className="rounded-lg border border-red-700/50 bg-red-900/20 px-4 py-3 text-sm text-red-300" role="alert">{error}</p>}
      {loading && !settings && <p className="text-sm text-zinc-500">Loading AI usage…</p>}
      {settings && <AIHealthPanel settings={settings} />}
      <p className="text-xs text-zinc-500">
        Change models or provider settings in <Link to="/crm/settings?tab=ai" className="text-[#FF10F0] hover:underline">Settings › AI</Link>.
      </p>
    </div>
  );
}
